module.exports = __webpack_public_path__ + "img/female-factory-960w.0747ad6.jpeg";